(() => {
 const setup = () => document.querySelectorAll('.brg-gallery').forEach(dialog => {
  if (dialog.dataset.bound) return;
  dialog.dataset.bound = 'true';
  const root = dialog.closest('.shopify-section');
  const track = dialog.querySelector('.brg-gallery__track');
  const slides = [...track.children];
  let opener, oldOverflow;
  const index = () => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
  const update = () => { dialog.querySelector('.brg-gallery__count').textContent = `${index()+1} / ${slides.length}`; };
  const move = delta => track.scrollTo({left: Math.max(0, Math.min(slides.length-1, index()+delta))*track.clientWidth, behavior:'smooth'});
  root.addEventListener('click', event => {
   const button = event.target.closest('.product__modal-opener--image .product__media-toggle');
   if (!button || !slides.length) return;
   const target = slides.findIndex(slide => slide.dataset.galleryMedia === button.dataset.mediaId);
   if (target < 0) return;
   event.preventDefault(); event.stopImmediatePropagation();
   opener = button; oldOverflow = document.body.style.overflow;
   dialog.showModal(); document.body.style.overflow = 'hidden';
   track.scrollTo({left:target*track.clientWidth,behavior:'instant'}); update();
  }, true);
  dialog.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
  dialog.querySelector('[data-gallery-prev]').addEventListener('click', () => move(-1));
  dialog.querySelector('[data-gallery-next]').addEventListener('click', () => move(1));
  track.addEventListener('scroll', update, {passive:true});
  dialog.addEventListener('keydown', event => {
   if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();move(event.key === 'ArrowRight' ? 1 : -1);}
  });
  dialog.addEventListener('close', () => {document.body.style.overflow = oldOverflow || ''; opener?.focus();});
 });
 document.addEventListener('DOMContentLoaded', setup);
 document.addEventListener('shopify:section:load', setup);
 setup();
})();
